import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IconArrowDownBlue from '../../../../assets/images/svg/icon-arrow-down-blue.svg';
import {Div} from "./styles";

const FaqComponent = ({ questions }) => {
	const [expandedIndices, setExpandedIndices] = useState([]);

	const toggleExpand = (index) => {
		setExpandedIndices((prevIndices) =>
			prevIndices.includes(index)
				? prevIndices.filter((i) => i !== index)
				: [...prevIndices, index]
		);
	};

	return (
		<Div>
			<ul className="list-none ml-0 my-4 border-t-1 border-b-1 border-tgbluelight divide-y-1 divide-tgbluelight divide-solid">
				{questions.map((question, index) => (
					<li className="pl-0 my-0" id={`item${index}`} key={index}>
						<div
							className="normal-case justify-normal flex items-center cursor-pointer flex-row justify-between text-white py-5"
							onClick={() => toggleExpand(index)}
						>
							<img
								className={`faq_caret transform p-1 ${expandedIndices.includes(index) ? 'rotate-180' : ''}`}
								src={IconArrowDownBlue}
								alt="toggle item"
							/>
							<div className="ml-2 font-serif text-lg md:text-xl font-extrabold text-tgnavy flex-1">
								<div dangerouslySetInnerHTML={{ __html: question.question }} />
							</div>
						</div>
						<div className={`max-w-3xl ${expandedIndices.includes(index) ? '' : 'hidden'}`}>
							<div className="mx-6 pb-2 text-tgnavy">
								<div dangerouslySetInnerHTML={{ __html: question.answer }} />
							</div>
						</div>
					</li>
				))}
			</ul>
		</Div>
	);
};

FaqComponent.propTypes = {
	questions: PropTypes.arrayOf(
		PropTypes.shape({
			question: PropTypes.string.isRequired,
			answer: PropTypes.string.isRequired,
		})
	).isRequired,
};

export default FaqComponent;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/faq_component/index.jsx